export const enum FONT_SIZE {
  SMALL = '0.75rem',
  SEMI_SMALL = '1rem',
  MEDIUM = '1.25rem',
  SEMI_LARGE = '1.5rem',
  LARGE = '1.75rem',
  EXTRA = '2.25rem',
}

export const enum FONT_WEIGHT {
  THIN = '300',
  REGULAR = '500',
  SEMI_BOLD = '700',
  BOLD = '800',
}
